/* eslint-disable no-unused-expressions */
import React, { useRef, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import classnames from 'classnames';

import makeStyles from '@mui/styles/makeStyles';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';

import MoreVertIcon from '@mui/icons-material/MoreVert';

import ConfirmButton from '@ts-core/components/ConfirmButton';

const useStyles = makeStyles(() => ({
  moreButton: {
    marginTop: -12,
    marginRight: -12,
  },
}));

const CourseCardMenu = (props) => {
  const classes = useStyles();
  const intl = useIntl();
  const { className, course, onRemoveCourse, onEditCourse } = props;

  const [menuOpen, setMenuOpen] = useState(false);
  const menuButtonRef = useRef();

  const handleEdit = useCallback(() => {
    setMenuOpen(false);
    onEditCourse?.(course);
  }, [onEditCourse, course]);

  const handleRemove = useCallback(() => {
    setMenuOpen(false);
    onRemoveCourse?.(course);
  }, [onRemoveCourse, course]);

  const handleOpenMenu = useCallback(() => {
    setMenuOpen(true);
  }, []);

  const handleCloseMenu = useCallback(() => {
    setMenuOpen(false);
  }, []);

  const menuExist = !!onRemoveCourse || !!onEditCourse;

  if (!menuExist) return null;

  return <>
    <IconButton
      ref={menuButtonRef}
      aria-label="Open more menu"
      color="inherit"
      className={classnames(classes.moreButton, className)}
      onClick={handleOpenMenu}
      size="large">
      <MoreVertIcon />
    </IconButton>
    <Menu
      id="simple-menu"
      anchorEl={menuButtonRef.current}
      open={menuOpen}
      onClose={handleCloseMenu}
    >
      {onEditCourse && (
        <MenuItem onClick={handleEdit}>
          <FormattedMessage id="button.edit.label" />
        </MenuItem>
      )}
      {onRemoveCourse && (
        <ConfirmButton
          renderButton={({ onClick }) => (
            <MenuItem onClick={onClick}>
              <FormattedMessage id="button.remove.label" />
            </MenuItem>
          )}
          onConfirm={handleRemove}
          onCancel={handleCloseMenu}
          alertMessage={intl.formatMessage(
            {
              id: 'dialog.confirmRemoveItem.title',
            },
            { item: course.name }
          )}
        />
      )}
    </Menu>
  </>;
};

CourseCardMenu.propTypes = {
  className: PropTypes.string,
  course: PropTypes.object.isRequired,
  onRemoveCourse: PropTypes.func,
  onEditCourse: PropTypes.func,
};

CourseCardMenu.defaultProps = {
  className: undefined,
  onRemoveCourse: undefined,
  onEditCourse: undefined,
};

export default CourseCardMenu;
